import { NgModule } from "@angular/core";
import { IMPORTS, DECLARATIONS, EXPORTS } from "./index";

@NgModule({
  declarations: [...DECLARATIONS],
  imports: [...IMPORTS],
  exports: [...EXPORTS],
})
export class MyProductsModule {}
